import { render, staticRenderFns } from "./StorePromo.vue?vue&type=template&id=364d4ef9&scoped=true&"
import script from "./StorePromo.vue?vue&type=script&lang=js&"
export * from "./StorePromo.vue?vue&type=script&lang=js&"
import style0 from "./StorePromo.vue?vue&type=style&index=0&id=364d4ef9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364d4ef9",
  null
  
)

export default component.exports